module.exports = __webpack_public_path__ + "img/pocket-6_en.5c00c1f.jpg";